export default {
  chat: {
    dialog: {
      salesChannel: {
        title: 'Sales Channel',
        message: 'The sales channel number has not been configured. Please configure it to continue.',
      },
    },
  },
  clientSearchField: {
    client: 'Client',
    prospect: 'Prospect',
    searchForAClient: 'Search for a client',
    searchForAProspect: 'Search for a prospect',
    copyText: 'Copy name',
    textCopied: 'Name copied to clipboard',
    copyFailed: 'Failed to copy name',
  },
};
